import { motion } from "framer-motion";
import { Sprout, Filter, PackageCheck, Ship } from "lucide-react";
import { PROCESS } from "@/data/site";
import { PROCESS_AR } from "@/data/content_ar";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useI18n } from "@/context/I18nContext";

const icons = { sprout: Sprout, sort: Filter, pack: PackageCheck, ship: Ship };

export default function Process() {
  const { t, lang } = useI18n();
  return (
    <section id="process" data-testid="process-section" className="relative z-10 bg-brand-soft border-y border-brand-border">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-28 lg:py-40">
        <div className="max-w-2xl">
          <Reveal><Eyebrow>{t("proc_eyebrow")}</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brand-fg leading-[1.02]">
              {t("proc_title1")} <span className="text-brand-gold italic">{t("proc_title2")}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}><p className="mt-6 text-brand-fg/70 leading-relaxed">{t("proc_intro")}</p></Reveal>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {PROCESS.map((step, i) => {
            const Icon = icons[step.key];
            const tr = lang === "ar" ? PROCESS_AR[step.n] : null;
            return (
              <Reveal key={step.n} delay={i * 0.08}>
                <div className="group relative h-full rounded-2xl border border-brand-border bg-brand-card p-8 hover:border-brand-gold/50 transition-colors overflow-hidden shadow-sm">
                  <div className="absolute -right-4 -top-6 font-display text-8xl text-brand-gold/10">{step.n}</div>
                  <span className="relative grid place-items-center h-14 w-14 rounded-full bg-brand-goldSoft text-brand-gold group-hover:bg-brand-gold group-hover:text-white transition-colors">
                    <Icon size={22} />
                  </span>
                  <h3 className="relative mt-6 font-display text-xl text-brand-fg leading-snug">{tr ? tr.title : step.title}</h3>
                  <p className="relative mt-3 text-sm text-brand-fg/70 leading-relaxed">{tr ? tr.body : step.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
